// Enums métier — valeurs stockées en base (sans accent ni espace).
// Libellés à afficher = mapping côté client (lib/format ou composants UI).
export const TerritoiresUser = ['Nord_Vendee_44', 'Sud_Vendee_17', 'Les_deux'];
export const RolesUser = ['commercial', 'admin'];
export const TypesClient = [
    'Paysagiste',
    'Negoce',
    'Camping',
    'Distributeur',
    'Particulier',
    'Autre',
];
export const TerritoiresContact = ['Adam', 'Matteo', 'Les_deux'];
export const SourcesContact = ['Salon', 'BAO', 'Web', 'Prospection', 'LeBonCoin', 'Autre'];
export const StatutsPipeline = [
    'Prospect',
    'Contacte',
    'Devis_envoye',
    'Negociation',
    'Gagne',
    'Perdu',
    'En_pause',
];
export const TypesInteraction = ['Appel', 'Email', 'Visite', 'Salon', 'Autre'];
export const ModesPaiement = ['Virement', 'Cheque', 'Especes'];
export const StatutsPaiement = ['Payee', 'En_attente', 'En_retard'];
export const ActionsAudit = ['create', 'update', 'delete', 'restore'];
// ─────────────────────────────────────────────────────────────────────
// Phase 4 — Trésorerie
// ─────────────────────────────────────────────────────────────────────
export const StatutsEcheance = ['En_attente', 'Payee', 'En_retard', 'Partielle'];
export const TypesAvoir = ['Credit', 'Remboursement'];
export const StatutsAvoir = ['Emis', 'Utilise', 'Rembourse', 'Annule'];
export const CategoriesChargeFixe = [
    'Loyer',
    'Salaires',
    'Cotisations_sociales',
    'Comptable',
    'Telecom',
    'Assurance',
    'Carburant',
    'Abonnements_logiciels',
    'Frais_bancaires',
    'Autres',
];
